export const ACTION_LEFT = 'left';
export const ACTION_RIGHT = 'right';
export const ACTION_UP = 'up';
export const ACTION_DOWN = 'down';
export const ACTION_RELAX = 'relax';
export const ACTION_CENTER = 'center';
export const ACTION_UP_RIGHT = 'up right';
export const ACTION_UP_LEFT = 'up left';
export const ACTION_DOWN_LEFT = 'down left';
export const ACTION_DOWN_RIGHT = 'down right';